/**
 * Furniture List is the current furniture items in the scene. It includes a
 * reference to the arya furniture and associates it with furniture data.
 */
import * as O from 'fp-ts/Option';
import { ModaSofa } from '@dora/backpack';
import * as RTK from '@reduxjs/toolkit';
import { Summary } from '../data/summary';

export type Item = {
    // The ID of the arya furniture for this furniture item
    aryaId: string;
    // IDs of all products used in the furniture - for simple products
    // this will always contain a single id
    productIds: Array<string>;
    // Types of individual objects within the furniture
    articleTypes: Array<string>;
    // For Moda Modular Sofa furniture, the sofa configuration
    configuration: O.Option<ModaSofa.Configuration>;
    // User-facing information for the logical item for this furniture item
    summary: Summary;
    // How item was added for analytics
    trigger: string;
};

export type State = Array<Item>;

const initialState: State = [];

export const slice = RTK.createSlice({
    name: 'furniture-list',
    initialState,
    reducers: {
        addFurniture(state, action: RTK.PayloadAction<Item>) {
            state.push(action.payload);
        },
        removeFurnitureByAryaId(state, action: RTK.PayloadAction<string>) {
            return state.filter(e => e.aryaId !== action.payload);
        },
    },
});

export const { addFurniture, removeFurnitureByAryaId } = slice.actions;

export const reducer = slice.reducer;
